import { DateTime } from 'luxon';
import { DatePickerType } from '../../DatePicker';
import { Theme } from '@routific/hive';

export const RANGE_BACKGROUND_COLOR = Theme.Colors.primary2; 

export const isWithinRange = (
  day: DateTime,
  rangeStart?: DateTime | null,
  rangeEnd?: DateTime | null,
): boolean => {
  if (!rangeStart || !rangeEnd) {
    return false;
  }

  return (
    day >= rangeStart?.startOf('day') && day <= rangeEnd?.startOf('day')
  );
};

export const getNewRangeEnd = (
  rangeType?: DatePickerType,
  hoveredDay?: DateTime | null,
  rangeEnd?: DateTime | null,
): DateTime | undefined | null => {
  if (rangeType === DatePickerType.END && hoveredDay) {
    return hoveredDay;
  } else {
    if (
      rangeType === DatePickerType.START &&
      hoveredDay && rangeEnd &&
      hoveredDay >= rangeEnd.startOf('day')
    ) {
      return undefined;
    }
    return rangeEnd;
  }
};
